import { render, staticRenderFns } from "./JindiaoGenericTable.vue?vue&type=template&id=10809beb&scoped=true"
import script from "./JindiaoGenericTable.vue?vue&type=script&lang=js"
export * from "./JindiaoGenericTable.vue?vue&type=script&lang=js"
import style0 from "./JindiaoGenericTable.vue?vue&type=style&index=0&id=10809beb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10809beb",
  null
  
)

export default component.exports